import {
  Directive,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
  AfterViewInit,
  Input,
  HostBinding,
} from '@angular/core';
import * as _ from 'lodash';

@Directive({
    selector: '[prEnableAfter]',
    standalone: false
})
export class prEnableAfter implements AfterViewInit {
  @Input('prEnableAfter') time: number;
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  mouseover;
  clickable: boolean = false;
  timerInterval;
  timer = 0;

  @HostBinding('style.transition')
  transition: string;

  ngAfterViewInit() {
    if (!this.time) this.time = 1000;
  }

  @HostListener('mouseover')
  onMouseOver() {
    this.transition = `all ${this.time / 1000}s ease-out`;
    this.timerInterval = setInterval(() => {
      if (this.timer >= this.time) {
        this.clickable = true;
        clearInterval(this.timerInterval);
      } else this.timer += 100;
    }, 100);
  }

  @HostListener('mouseout')
  onMouseOut() {
    this.clickable = false;
    this.transition = `all .25s ease-out`;
    clearInterval(this.timerInterval);
    this.timer = 0;
  }

  @HostListener('click')
  public onClick() {
    if (this.clickable) this.clicked.emit();
  }
}
